import React from "react";
import { useState, useEffect, useMemo } from "react";
import { DataGrid, getGridNumericOperators, getGridDateOperators  } from '@mui/x-data-grid';
import Rating from '@mui/material/Rating';
import { Box, Tabs, Tab, Typography, Divider } from "@mui/material";
import { TextField } from '@mui/material';
import { IoDocumentOutline } from "react-icons/io5";
import { FaVideo, FaFolder, FaImage, FaFileAudio, FaFile } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { esES } from '@mui/x-data-grid/locales';
import {Dialog,DialogTitle, DialogContent, DialogActions, Button, Grid} from '@mui/material';
import JSZip from 'jszip';
import { useSWRConfig } from "swr";
import "./styles/Administracion.css";
import CardResennas from "../View/component/CardResennas";
import { ComponerMensajeDialog } from './Mensajes';
import Swal from 'sweetalert2';

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';

//Grid Contenido (clases y cursos)
export const ClasesCursosGrid = () => {

    const ProductoRenderer = ({ producto }) => {
        
            if(producto.Nombre !== null && producto.Descripcion !== null && producto.Tematica !== null && producto.ImagenPortada !== null && producto.FechaSubida !== null){
                return(
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img src={`data:image/png;base64,${producto.ImagenPortada}`} alt={producto.Nombre} style={{ width: "50px", height: "50px", marginRight: "10px" }} />
                        <span>  {producto.Nombre}</span>
                    </div>
                );
            }
            else{
                <div>
                    <span>Producto eliminado</span>
                </div>
            }
        
    };

    const AccionRenderer = ({producto, verDetalles, solicitarEliminarProducto, comunicarTutor}) => {
        return (
            <div style={{display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center'}}>
                
                <button className="botonTabla1A" onClick={() => verDetalles(producto)}>
                    Ver
                </button>
                
                <button className="botonTabla3A" onClick={() => solicitarEliminarProducto(producto)}>
                    Eliminar
                </button>
                <button className="botonTablaAdmin" onClick={() => comunicarTutor(producto.tutor.Usuario)}>
                    Mensaje a tutor
                </button>
            </div>
        )
    }

    const compararNombre = (v1, v2) => {
        const nombre1 = v1.toString();
        const nombre2 = v2.toString();
        return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
    };

    const compararTipo = (v1, v2) => {
        const tipo1 = v1.toString();
        const tipo2 = v2.toString();
        return tipo1 > tipo2 ? 1 : tipo1 < tipo2 ? -1 : 0;
    };


    const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);


    //Filtrado

    //Filtrar Fecha
    function ValorFechaIntroducido(props) {
        const { item, applyValue, focusElementRef } = props;

        // Estado para la fecha
        const [fecha, setFecha] = useState(
            item.value
            ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
            : ''
        );
        const dateRef = React.useRef(null);

        React.useImperativeHandle(focusElementRef, () => ({
            focus: () => {
                if (dateRef.current) {
                    dateRef.current.focus();
                }
            },
        }));

        const handleFilterChange = (event) => {
            const newValue = event.target.value; // Viene en "YYYY-MM-DD"
            setFecha(newValue);
            if (newValue === '') {
            applyValue({ ...item, value: null });
            } else {
            const dateObj = new Date(newValue);
            if (!isNaN(dateObj)) {
                applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
            } else {
                applyValue({ ...item, value: null });
            }
            }
        };
        
        return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: 48,
                pl: '20px',
            }}
            >
            
            <TextField
                label="Fecha"
                type="date"
                value={fecha}
                onChange={handleFilterChange}
                inputRef={dateRef}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Box>
        );
    }

    //Grid tabla componente
    const GridTabla = ({ contenido, verDetalles, solicitarEliminarProducto, comunicarTutor }) => {
        
        //La información que se mostrará en filas está en contenido
        //Columnas
        const columns = useMemo(() => [
            {
                field: "productos",
                headerName: "Producto",
                width: 430,
                renderCell: (params) => {
                    const producto = params.row;
                    return <ProductoRenderer producto={producto} />; 
                },
                valueGetter: (value, row) => row.Nombre,
                sortComparator: compararNombre, 
                sortable: true,   
                filterable: true, 
            },
            {
            field: "tutor",
            headerName: "Tutor",
            width: 180,
            valueGetter: (value, row) => row.tutor.Usuario || "",
            renderCell: (params) => {
                if(params.row.tutor){
                    return <span>{params.row.tutor.Usuario}</span>
                }
                else{
                    return <span>Tutor eliminado</span>
                }
            },
            sortComparator: compararNombre,
            sortable: true,
            filterable: true,
            },
            {   
                field: "Fecha",
                headerName: "Fecha de publicación",
                width: 180,
                renderCell: (params) => {
                    const rawFecha = params.row.FechaSubida;
                    const fecha = new Date(rawFecha);
                    if (isNaN(fecha)) return "Fecha inválida";
                    return fecha.toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric"
                    }).replace(/\//g, "-");
                },
                valueGetter: (value, row) => new Date(row.FechaSubida),
                sortComparator: compararFecha,
                sortable: true,   
                filterable: true,
                filterOperators: getGridDateOperators()
                    .filter((operator) => operator.value !== 'isAnyOf')
                    .map((operator) => ({
                        ...operator,
                        InputComponent: operator.InputComponent
                            ? ValorFechaIntroducido
                            : undefined,
                    })),
            },
            {
                field: "Tipo",
                headerName: "Tipo",
                width: 170,
                renderCell: (params) => {
                    const tipo = params.row.tipo;
                    if(tipo === "curso") return <span>Curso</span>;
                    else if(tipo === "claseParticular") return <span>Clase particular</span>;
                    else return <span>Clase</span>
                },
                valueGetter: (value, row) => row.tipo,
                sortComparator: compararTipo, 
                sortable: true,   
                filterable: true, 
            },
            {
                field: "Accion",
                headerName: "Accion",
                width: 360,
                renderCell: (params) => <AccionRenderer producto={params.row} verDetalles={verDetalles} solicitarEliminarProducto={solicitarEliminarProducto} comunicarTutor={comunicarTutor} />,
                sortable: false,   
                filterable: false, 
            },
        ]);

        return (
            <div className="gridContainerAdmin">
                <DataGrid 
                    rows={contenido}
                    columns={columns.map(col => ({
                        ...col,
                        headerAlign: 'center', // Centra el encabezado de la columna
                        align: 'center', // Centra el contenido de la celda
                    }))}                
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                        borderColor: 'var(--text-principal)',
                        color: 'var(--text-principal)', 
                        fontSize: "14px",
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#fff',
                            color: 'black',
                            fontWeight: 'bold',
                            borderBottom: '0.25px solid var(--text-principal)'
                        },
                        "& .MuiTablePagination-displayedRows": {
                            color: "#fff", 
                        },
                        "& .MuiDataGrid-footerContainer": {
                            color: 'var(--text-principal)',  
                            fontWeight: "bold",
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                        },
                        '& .MuiDataGrid-sortIcon': {
                            color: 'black', // Cambia el color de la flecha de ordenación
                        },
                        '& .MuiDataGrid-menuIconButton svg': {
                            color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                        },
                        // 'Filas por página:' texto
                        "& .MuiTablePagination-selectLabel": {
                            color: 'var(--text-principal)',
                        },
                        // Selector desplegable (100)
                        "& .MuiInputBase-root": {
                            color: "var(--text-principal)",
                        },
                    
                        // Opciones del selector al abrirse
                        "& .MuiMenuItem-root": {
                            color: "black", // texto de los items cuando se despliega el select
                        },
                    
                        // '1–7 de 7'
                        "& .MuiTablePagination-displayedRows": {
                             color: "var(--text-principal)",
                        },
                    
                        // Flechas de navegación
                        "& .MuiSvgIcon-root": {
                            color: "var(--text-principal)",
                        },
                        // Bordes de las filas
                        '& .MuiDataGrid-row': {
                            borderBottom: '0.25px solid var(--text-principal)', 
                        },
                        // Borde del selector
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff",
                        },
                    
                        // Icono del desplegable (flecha abajo del select)
                        "& .MuiSelect-icon": {
                            color: "var(--text-principal)",
                        },
                        // Icono menú cabecera
                        "& .MuiDataGrid-columnHeaderMenuIcon": {
                            color: "black",
                        },
                    }}
                    localeText={{
                        ...esES.components.MuiDataGrid.defaultProps.localeText,
                        rowsPerPage: "Filas por página:",
                    }}
                    
                />
            </div>
        );
    };

    const [contenido, setContenido] = useState([]);
    const [loading, setLoading] = useState(true);
    const { mutate } = useSWRConfig();

    const [seleccion, setSeleccion] = useState(null); //Seleccionar producto
    const [abiertoDetalle, setAbiertoDetalle] = useState(false);  //Abrir modal
    const [confirmarEliminacion, setconfirmarEliminacion] = useState(false); //Abrir modal de eliminacion

    
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });
        
    // getIcono para renderizar el icono correcto
    const getIcono = (archivo) => {
        if (archivo.isDirectory) return <FaFolder />;
        switch (archivo.tipo) {
            case 'Documento': return <IoDocumentOutline />;
            case 'Video':     return <FaVideo />;
            case 'Audio':     return <FaFileAudio />;
            case 'Foto':      return <FaImage />;
            default:          return <FaFile />;
        }
    };

    useEffect(() => {
        const fetchProductos = async () => {
            setLoading(true);
            try{
                
                //Realizar las 2 peticiones en paralelo
                const endpoints = [
                    {url: `${baseUrl}/api/clases/`, collection: 'clases' },
                    {url: `${baseUrl}/api/cursos/`, collection: 'cursos'},
                ];

                // Función auxiliar para obtener los datos y añadir el atributo "tipo" según la colección
                const fetchWithTipo = async ({ url, collection }) => {
                    const response = await fetch(url);
                    const data = await response.json();
                    if (Array.isArray(data)) {
                        if (collection === 'cursos') {
                            return data.map(item => ({ ...item, tipo: 'curso' }));
                        } else if (collection === 'clases') {
                            return data.map(item => ({
                                ...item,
                                tipo: item.Particular ? 'claseParticular' : 'clase'
                            }));
                        }
                    }
                    return [];
                };

                const resultados = await Promise.all(endpoints.map(endpoint => fetchWithTipo(endpoint)));
                const productosCompletos = resultados.flat();
                
                const productosConTutor = await Promise.all(
                    productosCompletos.map(async (item) => {
                        let tutorData = null;
                        if (item.Id_Tutor) {
                        try {
                            const respTutor = await fetch(`${baseUrl}/api/users/${item.Id_Tutor}`);
                            if (respTutor.ok) {
                            const tutorJson = await respTutor.json();
                            tutorData = { _id: tutorJson._id, Usuario: tutorJson.Usuario };
                            }
                        } catch (error) {
                            console.error(`Error obteniendo tutor para ${item.Nombre}:`,error);
                        }
                        }
                        return {
                            ...item,
                            tutor: tutorData, 
                        };
                    })
                );
        
                setContenido(productosConTutor);
            } catch (error){
                console.error("Error al obtener los productos", error);
            } finally{
                setLoading(false);
            }
        };

        fetchProductos();
    }, []);

    const [archivos, setArchivos] = useState([]);
    const [sesiones, setSesiones] = useState([]);
    
    useEffect(() => {
        if (!seleccion) return;

        if (seleccion.tipo === 'curso' && seleccion.Archivos) {
        const data = typeof seleccion.Archivos === 'string' ? Uint8Array.from(atob(seleccion.Archivos), c => c.charCodeAt(0)).buffer : seleccion.Archivos;

        const zip = new JSZip();
        zip.loadAsync(data).then((z) => {
            const lista = [];
            z.forEach((relativePath, zipEntry) => {
                // extraer extensión
                const partes = relativePath.split('.');
                const ext = partes.length > 1
                    ? partes.pop().toLowerCase()
                    : '';

                // inferir tipo
                let tipo = 'Desconocido';
                if (['pdf','doc','docx','xls','xlsx','ppt','pptx','txt','odt'].includes(ext)) {
                    tipo = 'Documento';
                } else if (['mp4','avi','mkv','mov','wmv'].includes(ext)) {
                    tipo = 'Video';
                } else if (['mp3','wav','aac','flac'].includes(ext)) {
                    tipo = 'Audio';
                } else if (['jpg','jpeg','png','gif','bmp','webp'].includes(ext)) {
                    tipo = 'Foto';
                }
                lista.push({
                    nombre: relativePath,
                    isDirectory: zipEntry.dir,
                    tamaño: zipEntry._data.uncompressedSize,
                    tipo,
                });
            });
            setArchivos(lista);
        }).catch(console.error);
        }

        if (seleccion.tipo !== 'curso' && Array.isArray(seleccion.Id_Sesion)) {
        Promise.all(seleccion.Id_Sesion.map(id => fetch(`${baseUrl}/api/sesiones/${id}`).then(r => r.json()))).then(setSesiones).catch(console.error);
        }
    }, [seleccion]);

    //Ver detalles del producto
    const manejarvistaDetalles = (producto) => {
        setSeleccion(producto);
        setAbiertoDetalle(true);
    }

    //Eliminación del contenido
    //Mostrar dialogo de eliminación
    const solicitarEliminarProducto = (producto) => {
        setAbiertoDetalle(false);
        setSeleccion(producto);
        setconfirmarEliminacion(true);
    }

    //Eliminación del producto
    const manejarEliminacionProducto = async() => {
        try{
            let url = '';
            if(seleccion.tipo === 'curso') url = `${baseUrl}/api/cursos/${seleccion._id}`
            else url = `${baseUrl}/api/clases/${seleccion._id}`
            
            const resp = await fetch(url, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!resp.ok) {
                const err = await resp.json();
                throw new Error(err.message || `HTTP ${resp.status}`);
            }

            //Actualizar el estado local filtrando el eliminado
            setContenido(prev =>
                prev.map(item =>
                    item._id === seleccion._id
                    ? {
                        ...item,
                        Nombre: null,
                        Tematica: null,
                        Descripcion: null,
                        ImagenPortada: null,
                        FechaSubida: null,
                    }
                    : item
                )
            );
            await mutate([
                `${baseUrl}/api/cursos/`,
                `${baseUrl}/api/clases/`
            ]);
            await mutate(`${baseUrl}/api/productos/${seleccion._id}`);
            await mutate(`${baseUrl}/api/compras/search/contenido/${seleccion?._id}`);
            await mutate(`${baseUrl}/api/users/tutor/${seleccion.Id_Tutor}`);
            Swal.fire({
                icon: 'success',
                title: '¡Producto eliminado!',
                text: `El producto "${seleccion.Nombre}" se ha eliminado correctamente.`,
                confirmButtonText: 'Aceptar'
            })        
        } catch(error){
            console.error('Error al eliminar producto:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error con el servidor',
                text: 'Error al eliminar el producto'
            }); 
        }
        finally{
            setconfirmarEliminacion(false);
            setSeleccion(null);
        }
    }

    //Cierre del dialogo de ver detalles
    const manejarCierre = () => {
        setAbiertoDetalle(false);
        setSeleccion(null);
    }

     const comunicarTutor = (tutor) => {
        if (!tutor) {
           Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Tutor no disponible'
            }); 
            return;
        }
        setCompose({
        abierto: true,
        inicial: {
            Destinatarios: tutor,
            Asunto: "",
            Contenido: "",
            Archivo: null,
            respuestaA: false,
            leerSoloDestinatarios: true,
            leerSoloAsunto: false,
        },
        });
    };


    return(
        <div>
            <h2 style={{marginBottom:'10px'}}>Contenido</h2>   
            <div className="containerAdmin">
                {loading ? (
                    <div className="noMostrar">
                        <p>Cargando contenido...</p>
                    </div>
                ) : contenido.filter(item => item.Nombre !== null && item.Descripcion !== null && item.FechaSubida !== null && item.ImagenPortada !== null && item.Tematica !== null).length === 0 ? (
                    <div className="noMostrar">
                        <p>Aún no ha subido ningún contenido</p>
                    </div>
                ) : (
                    <GridTabla 
                        contenido={contenido.filter(item => 
                            item.Nombre !== null &&
                            item.Descripcion !== null &&
                            item.Tematica !== null &&
                            item.ImagenPortada !== null &&
                            item.FechaSubida !== null
                        )} 
                        verDetalles={manejarvistaDetalles} 
                        solicitarEliminarProducto={solicitarEliminarProducto}
                        comunicarTutor={comunicarTutor}
                    />
                )}
            </div>

            {/*Modal para ver detalles*/}
            <Dialog open={abiertoDetalle} onClose={manejarCierre} fullWidth maxWidth="md">
                <DialogTitle>{`${seleccion?.Nombre || ""}`}</DialogTitle>
                <DialogContent dividers sx={{maxHeight: '70vh',overflowY: 'auto',}}>
                    {seleccion && (
                        <>
                            <div className="cabeceraModalAdmin"> 
                                <div className="imagenModalAdmin">
                                    <img src={`data:image/png;base64,${seleccion.ImagenPortada}`} alt={seleccion.Nombre} style={{ width: "80px", height: "80px", marginRight: "10px" }} />
                                </div> 
                                <div>
                                    <Typography gutterBottom variant="h5">{seleccion.Nombre}</Typography>
                                    <Typography gutterBottom color="text.secondary">Tipo: {seleccion.tipo === 'clase' ? 'Clase' : (seleccion.tipo === 'curso' ? 'Curso' : 'Clase particular')}</Typography>
                                    <Typography gutterBottom><strong>Descripcion: </strong>{seleccion.Descripcion}</Typography>
                                    <Typography gutterBottom><strong>Precio: </strong>{(seleccion.Precio).toFixed(2)} €</Typography>
                                </div>
                            </div>

                        <Divider sx={{my: 2}}/>

                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <Typography gutterBottom><strong>Temáticas: </strong> {seleccion.Tematica.join(", ").toString()}</Typography>
                                <Typography gutterBottom>
                                    <strong>Fecha de publicación: </strong>{new Date (seleccion.FechaSubida).toLocaleDateString("es-ES", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    }).replace(/\//g, "-")}
                                </Typography>

                                {seleccion.tipo === 'curso' ? (
                                    <Typography gutterBottom> <strong>Duración: </strong> {seleccion.Duracion} minutos </Typography>
                                ) : (
                                <>
                                    <Typography gutterBottom>
                                        <strong>Fecha de inicio: </strong>
                                        {new Date (seleccion.FechaInicio).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).replace(/\//g, "-")} 
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Fecha de finalización: </strong>
                                        {new Date (seleccion.FechaFin).toLocaleDateString("es-ES", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        }).replace(/\//g, "-")}
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Particular: </strong> {seleccion.Particular ? 'Sí' : 'No' } 
                                    </Typography>

                                    <Typography gutterBottom>
                                        <strong>Nº plazas: </strong> {seleccion.Plazas}
                                    </Typography>
                                </>
                                )}
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 2 }} />

                        {seleccion.tipo === 'curso' && archivos.length > 0 && (
                        <div>
                            <Typography variant="h6" gutterBottom>Contenido del curso</Typography>
                            <ul className="listaFicherosAdmin">
                                {archivos
                                    .filter(a => a.isDirectory)
                                    .map(directorio => (
                                        <li key={directorio.nombre} className="listaFicheros_dirAdmin">
                                            <Typography component="div" gutterBottom>
                                                <strong>
                                                    {getIcono(directorio)}{' '}
                                                    {directorio.nombre.replace(/\/$/, '')}
                                                </strong>
                                            </Typography>
                                            <ul className="listaFicheros_subAdmin">
                                                {archivos
                                                    .filter(a => !a.isDirectory && a.nombre.startsWith(directorio.nombre))
                                                    .map(archivo => (
                                                    <li key={archivo.nombre}>
                                                        <Typography component="div">
                                                            {getIcono(archivo)}{' '}
                                                            {archivo.nombre.replace(directorio.nombre, '')} —{' '}
                                                            Tamaño: {archivo.tamaño} KB
                                                        </Typography>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    ))}

                                    {archivos
                                        .filter(a => !a.isDirectory && !a.nombre.includes('/'))
                                        .map(archivo => (
                                            <li key={archivo.nombre}>
                                                <Typography component="div">
                                                    {getIcono(archivo)} {archivo.nombre} — Tamaño: {archivo.tamaño} KB
                                                </Typography>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                            )}

                            {seleccion.tipo !== 'curso' && sesiones.length > 0 && (
                            <div>
                                <Typography variant="h6" gutterBottom>Sesiones de la clase</Typography>
                                <ul className="listaSesionAdmin">
                                    {sesiones.map((sesion, i) => (
                                        <li key={i}>
                                            <Typography gutterBottom>
                                                <SiGoogleclassroom />{' '}
                                                {sesion.Parte}. {sesion.Nombre} — Fecha:{' '}
                                                {(() => {
                                                    const fecha = new Date(sesion.Fecha);
                                                    const fechaStr = fecha.toLocaleDateString("es-ES", {
                                                        day: "2-digit",
                                                        month: "2-digit",
                                                        year: "numeric"
                                                    }).replace(/\//g, "-");
                                                    const horaStr = fecha.toLocaleTimeString("es-ES", {
                                                        hour: "2-digit",
                                                        minute: "2-digit"
                                                    });
                                                    return `${fechaStr} a las ${horaStr}`;
                                                })()} — Duración:{' '}{sesion.Duracion} minutos
                                            </Typography>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            )}
                        </>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={manejarCierre}>Cerrar</Button>
                </DialogActions>
            </Dialog>

            {/*Modal para eliminar clase o curso */}
            <Dialog
                open={confirmarEliminacion}
                onClose={() => setconfirmarEliminacion(false)}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    {`Eliminar ${seleccion?.Nombre}`}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        {seleccion?.tipo === 'curso' ? (
                            <>
                                ¿Estás seguro de que deseas eliminar <strong>{seleccion?.Nombre}</strong>? Después no podrá deshacer el cambio.
                            </>
                        ) : (
                            <>
                                ¿Estás seguro de que deseas eliminar <strong>{seleccion?.Nombre}</strong> y todas sus sesiones asociadas? Después no podrá deshacer el cambio.
                            </>
                        )}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={() => setconfirmarEliminacion(false)}>No</Button>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} color="error" onClick={manejarEliminacionProducto}>
                        Sí, eliminar
                    </Button>
                </DialogActions>
            </Dialog>

            <ComponerMensajeDialog
                abierto={compose.abierto}
                inicial={compose.inicial}
                onClose={() => setCompose({ abierto: false, inicial: {} })}
            />
        </div>
    );
}

//Grid Compras
export const ComprasGrid = () => {
    
    const AccionRenderer = ({ row, devolverProducto, solicitarEliminarCompra, comunicarTutor, comunicarCliente}) => (
        <div style={{display: 'flex', gap: 8, justifyContent: 'center', alignItems: 'center'}}>
            {row.devuelto ? (
                <Typography color="#fafafa">Devuelto</Typography>
            ) : (
                <button
                className="botonTabla1A"
                onClick={() => devolverProducto(row)}
                >
                    Devolver
                </button>
            )}
            <button
                className="botonTabla3A"
                onClick={() => solicitarEliminarCompra(row)}
            >
                Eliminar compra
            </button>
            <button
                className="botonTablaAdmin"
                onClick={() => comunicarTutor(row)}
            >
                Mensaje a tutor
            </button>
            <button
                className="botonTablaAdmin"
                onClick={() => comunicarCliente(row)}
            >
                Mensaje a cliente
            </button>
        </div>
    );

    const compararTexto = (v1, v2) => {
        const nombre1 = v1.toString();
        const nombre2 = v2.toString();
        return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
    };

    
    const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);

    //Filtrado
    //Filtrar Fecha
    function ValorFechaIntroducido(props) {
        const { item, applyValue, focusElementRef } = props;

        // Estado para la fecha
        const [fecha, setFecha] = useState(
            item.value
            ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
            : ''
        );
        const dateRef = React.useRef(null);

        React.useImperativeHandle(focusElementRef, () => ({
            focus: () => {
                if (dateRef.current) {
                    dateRef.current.focus();
                }
            },
        }));

        const handleFilterChange = (event) => {
            const newValue = event.target.value; // Viene en "YYYY-MM-DD"
            setFecha(newValue);
            if (newValue === '') {
            applyValue({ ...item, value: null });
            } else {
            const dateObj = new Date(newValue);
            if (!isNaN(dateObj)) {
                applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
            } else {
                applyValue({ ...item, value: null });
            }
            }
        };
        
        return (
            <Box
                sx={{
                    display: 'inline-flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    height: 48,
                    pl: '20px',
                }}
                >
                
                <TextField
                    label="Fecha"
                    type="date"
                    value={fecha}
                    onChange={handleFilterChange}
                    inputRef={dateRef}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box>
        );
    }

    const [compras, setCompras] = useState([]);
    const [loading, setLoading] = useState(true);

    const [seleccion, setSeleccion] = useState(null);

    // Para el diálogo "Confirmar eliminación"
    const [confirmarEliminacionCompra, setConfirmarEliminacionCompra] = useState(false);

    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    useEffect(() => {
        const fetchComprasCompleto = async () => {
            setLoading(true);
            try{
                const respuesta = await fetch(`${baseUrl}/api/compras/search/allCompras`)
                if(!respuesta.ok) throw new Error("Error al obtener las compras");
                const datos = await respuesta.json();
                setCompras(datos);
            } catch(error){
                console.error("Error obteniendo compras: ", error);
                setCompras([]);
            } finally {
                setLoading(false);
            }
        };
        fetchComprasCompleto();
    }, []);


    const devolverProducto = async (row) => {
        const producto = row.producto;
        const cliente = row.cliente;
        const cantidadDevolver = Math.round((producto?.Precio || 0) * 100);

        const confirmarResultado = await Swal.fire({
            title: `¿Seguro que quieres devolver ${(cantidadDevolver / 100).toFixed(2)} € del producto "${producto.Nombre}" al usuario ${cliente.Usuario}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, devolver',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
        });        
        
        if (!confirmarResultado.isConfirmed) return;

        try {
            const respuesta = await fetch(`${baseUrl}/api/pago/refund`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                prod: producto?._id,
                cliente: cliente?._id,
                cantidadDevolver,
                }),
            });

            if (!respuesta.ok) {
                const errorJson = await respuesta
                    .json()
                    .catch(() => ({ error: "Error al solicitar el reembolso" }));
                Swal.fire({
                    icon: 'error',
                    title: 'Error al procesar la devolución',
                    text: `No se pudo procesar la devolución:\n${errorJson.error || JSON.stringify(errorJson)}`,
                    confirmButtonText: 'Aceptar'
                });
                return;
            }

            const { amount } = await respuesta.json();
            Swal.fire({
                icon: 'success',
                title: 'Devolución procesada',
                html: `
                    &middot; Importe devuelto: ${(amount / 100).toFixed(2)} €<br/>
                    &middot; Cliente: ${cliente?.Usuario}
                `,
                confirmButtonText: 'Aceptar'
            });
                        
            // Actualizar estado local: marcar como devuelto
            setCompras((prev) =>
                prev.map((c) =>
                c._id === row._id &&
                c.Id_Contenido.toString() === row.Id_Contenido.toString()
                    ? {
                        ...c,
                        devuelto: true,
                        ProductosDevueltos: [
                        ...c.ProductosDevueltos,
                        row.Id_Contenido,
                        ],
                    }
                    : c
                )
            );
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error en el servidor',
                text: `Ha ocurrido un error inesperado al procesar la devolución.`,
                confirmButtonText: 'Aceptar'
            });

        }
    };


    const solicitarEliminarCompra = (compra) => {
        setSeleccion(compra);
        setConfirmarEliminacionCompra(true);
    };

    const manejarEliminacionCompra= async () => {
        if (!seleccion) return;

        const compraId = seleccion._id;
        const contenidoABorrar = seleccion.idContenido;

        try {
            const res = await fetch(`${baseUrl}/api/compras/contenido/${seleccion._id}/${seleccion.Id_Contenido}`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            });
            if (!res.ok) throw new Error("No se pudo eliminar la compra");

            setCompras(prev => {
                return prev.reduce((acum, c) => {
                    // Si no es la compra afectada, la dejamos tal cual:
                    if (c._id !== compraId) {
                        acum.push(c);
                        return acum;
                    }
                
                    const contenidoPrevio = Array.isArray(c.Id_Contenido) ? c.Id_Contenido : [];

                    const nuevoArrayContenidos = contenidoPrevio.filter(
                        id => id.toString() !== contenidoABorrar.toString()
                    );
            
                    if (nuevoArrayContenidos.length > 0) {
                    acum.push({
                        ...c,
                        Id_Contenido: nuevoArrayContenidos
                    });
                }

                    sessionStorage.setItem("admin_indiceTab", "1");
                    window.location.reload();
                    return acum;
                }, []);
            });
            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Compra eliminada correctamente',
                confirmButtonText: 'Aceptar'
            });
        } catch (err) {
            console.error("Error al la compra:", err);
            Swal.fire({
                icon: 'error',
                title: 'Error en el servidor',
                text: `Ha ocurrido un error inesperado al eliminar la compra`,
                confirmButtonText: 'Aceptar'
            });
        } finally {
            setConfirmarEliminacionCompra(false);
            setSeleccion(null);
        }
    };

    // Funciones para abrir diálogos de mensaje
    const comunicarTutor = (row) => {
        if (!row.tutor) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Tutor no disponible'
            }); 
            return;
        }
        setCompose({
        abierto: true,
        inicial: {
            Destinatarios: row.tutor.Usuario,
            Asunto: "",
            Contenido: "",
            Archivo: null,
            respuestaA: false,
            leerSoloDestinatarios: true,
            leerSoloAsunto: false,
        },
        });
    };

    const comunicarCliente = (row) => {
        if (!row.cliente) {
        Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Cliente no disponible'
            }); 
        return;
        }
        setCompose({
            abierto: true,
            inicial: {
                Destinatarios: row.cliente.Usuario,
                Asunto: "",
                Contenido: "",
                Archivo: null,
                respuestaA: false,
                leerSoloDestinatarios: true,
                leerSoloAsunto: false,
            },
        });
    };

  const GridTabla = ({ compras }) => {
    const columns = useMemo(
      () => [
        {
          field: "Codigo",
          headerName: "Código",
          width: 100,
          valueGetter: (value, row) => row.Codigo,
          sortComparator: compararTexto,
          sortable: true,
          filterable: true,
        },
        {   
            field: "Fecha",
            headerName: "Fecha de compra",
            width: 160,
            renderCell: (params) => {
                const rawFecha = params.row.Fecha;
                const fecha = new Date(rawFecha);
                if (isNaN(fecha)) return "Fecha inválida";
                return fecha.toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric"
                }).replace(/\//g, "-");
            },
            valueGetter: (value, row) => new Date(row.Fecha),
            sortComparator: compararFecha,
            sortable: true,   
            filterable: true,
            filterOperators: getGridDateOperators()
                .filter((operator) => operator.value !== 'isAnyOf')
                .map((operator) => ({
                    ...operator,
                    InputComponent: operator.InputComponent
                        ? ValorFechaIntroducido
                        : undefined,
                })),
        },
        {
          field: "producto",
          headerName: "Producto",
          width: 250,
          renderCell: (params) =>  {
            if(params.row.producto.Nombre === null && 
            params.row.producto.Descripcion === null &&
            params.row.producto.ImagenPortada === null &&
            params.row.producto.FechaSubida === null &&
            params.row.producto.Tematica === null){
                return <span>Producto eliminado</span>;
            }

            return <span>{params.row.producto.Nombre}</span>
            
          },
          valueGetter: (value, row) => row.producto?.Nombre || "",
          sortComparator: compararTexto,
          sortable: true,
          filterable: true,
        },
        {
          field: "Precio",
          headerName: "Precio",
          width: 100,
          renderCell: (params) =>  <span>{(params.row.producto.Precio).toFixed(2)} €</span>,
          valueGetter: (value, row) => parseFloat(row.producto.Precio),
          sortComparator: (v1, v2) => parseFloat(v1) - parseFloat(v2),
          sortable: true,
          filterable: true,
        },
        {
          field: "cliente",
          headerName: "Cliente",
          width: 120,
          renderCell: (params) => {
            if(params.row.cliente){
              return <span>{params.row.cliente.Usuario}</span>
            }
            else{
              return <span>Cliente eliminado</span>
            }
          },
          valueGetter: (value, row) => row.cliente?.Usuario || "",
          sortComparator: compararTexto,
          sortable: true,
          filterable: true,
        },
        {
          field: "tutor",
          headerName: "Tutor",
          width: 120,
          renderCell: (params) => { 
            if(params.row.tutor){
              return <span>{params.row.tutor.Usuario}</span>
            }
            else{
              return <span>Tutor eliminado</span>
            }
          },
          valueGetter: (value, row) => row.tutor?.Usuario || "",
          sortComparator: compararTexto,
          sortable: true,
          filterable: true,
        },
        {
          field: "Acciones",
          headerName: "Acción",
          width: 600,
          renderCell: (params) => (
            <AccionRenderer
              row={params.row}
              devolverProducto={devolverProducto}
              solicitarEliminarCompra={solicitarEliminarCompra}
              comunicarTutor={comunicarTutor}
              comunicarCliente={comunicarCliente}
            />
          ),
          sortable: false,
          filterable: false,
        },
      ],
      []
    );

    return (
        <div className="gridContainerAdmin">
            <DataGrid
                rows={compras}
                columns={columns.map((col) => ({
                    ...col,
                    headerAlign: "center",
                    align: "center",
                }))}
                pageSize={20}
                rowsPerPageOptions={[20]}
                disableSelectionOnClick
                getRowId={(row) =>
                `${row._id.toString()}_${row.Id_Contenido.toString()}`
                }
                // Identificador único con _id y contenido
                sx={{
                        borderColor: 'var(--text-principal)',
                        color: 'var(--text-principal)', 
                        fontSize: "14px",
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#fff',
                            color: 'black',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            borderBottom: '0.25px solid var(--text-principal)'
                        },
                        "& .MuiTablePagination-displayedRows": {
                            color: "#fff", 
                        },
                        "& .MuiDataGrid-footerContainer": {
                            color: 'var(--text-principal)', 
                            fontWeight: "bold",
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                        },
                        '& .MuiDataGrid-sortIcon': {
                            color: 'black', // Cambia el color de la flecha de ordenación
                        },
                        '& .MuiDataGrid-menuIconButton svg': {
                            color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                        },
                        // 'Filas por página:' texto
                        "& .MuiTablePagination-selectLabel": {
                             color: 'var(--text-principal)',
                        },
                        // Selector desplegable (100)
                        "& .MuiInputBase-root": {
                            color: "var(--text-principal)",
                        },
                    
                        // Opciones del selector al abrirse
                        "& .MuiMenuItem-root": {
                            color: "black", // texto de los items cuando se despliega el select
                        },
                    
                        // '1–7 de 7'
                        "& .MuiTablePagination-displayedRows": {
                            color: "var(--text-principal)",
                        },
                    
                        // Flechas de navegación
                        "& .MuiSvgIcon-root": {
                            color: "var(--text-principal)",
                        },
                        // Bordes de las filas
                        '& .MuiDataGrid-row': {
                            borderBottom: '0.25px solid var(--text-principal)', 
                        },
                        // Borde del selector
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff",
                        },
                    
                        // Icono del desplegable (flecha abajo del select)
                        "& .MuiSelect-icon": {
                            color: "var(--text-principal)",
                        },
                        // Icono menú cabecera
                        "& .MuiDataGrid-columnHeaderMenuIcon": {
                            color: "black",
                        },
                }}
                localeText={{
                ...esES.components.MuiDataGrid.defaultProps.localeText,
                rowsPerPage: "Filas por página:",
                }}
      />
    </div>
    );
  };

return (
    <div>
        <h2 style={{marginBottom:'10px'}}>Compras</h2>
        <div className="containerAdmin">
            {loading ? (
            <div className="noMostrar">
                <p>Cargando compras...</p>
            </div>
            ) : compras.length === 0 ? (
            <div className="noMostrar">
                <p>No hay compras disponibles</p>
            </div>
            ) : (
            <GridTabla compras={compras} />
            )}
        </div>

        <Dialog
            open={confirmarEliminacionCompra}
            onClose={() => setConfirmarEliminacionCompra(false)}
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle>
                {seleccion ? `Eliminar compra del producto ${seleccion.producto.Nombre} de la compra con Código ${seleccion.Codigo}` : "Eliminar Compra"}
            </DialogTitle>
            <DialogContent>
                <Typography>
                    ¿Estás seguro de que deseas eliminar esta compra? Esta acción no se puede deshacer.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={() => setConfirmarEliminacionCompra(false)}>No</Button>
                <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} color="error" onClick={manejarEliminacionCompra}>
                    Sí, eliminar
                </Button>
            </DialogActions>
        </Dialog>

        <ComponerMensajeDialog
            abierto={compose.abierto}
            inicial={compose.inicial}
            onClose={() => setCompose({ abierto: false, inicial: {} })}
        />
    </div>
);

}


//Grid Reseñas
export const ReseñasGrid = () => {

    const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);

    //Filtrado
    //Filtrar Fecha
    function ValorFechaIntroducido(props) {
        const { item, applyValue, focusElementRef } = props;

        // Estado para la fecha
        const [fecha, setFecha] = useState(
            item.value
            ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
            : ''
        );
        const dateRef = React.useRef(null);

        React.useImperativeHandle(focusElementRef, () => ({
            focus: () => {
                if (dateRef.current) {
                    dateRef.current.focus();
                }
            },
        }));

        const handleFilterChange = (event) => {
            const newValue = event.target.value; // Viene en "YYYY-MM-DD"
            setFecha(newValue);
            if (newValue === '') {
            applyValue({ ...item, value: null });
            } else {
            const dateObj = new Date(newValue);
            if (!isNaN(dateObj)) {
                applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
            } else {
                applyValue({ ...item, value: null });
            }
            }
        };
        
        return (
            <Box
                sx={{
                    display: 'inline-flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    height: 48,
                    pl: '20px',
                }}
            >
                
                <TextField
                    label="Fecha"
                    type="date"
                    value={fecha}
                    onChange={handleFilterChange}
                    inputRef={dateRef}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </Box>
        );
    }

    const [resenas, setResenas] = useState([]);
    const [loading, setLoading] = useState(true);

    const [seleccion, setSeleccion] = useState(null); 
    const [abierto, setAbierto] = useState(false);

    const [confirmarEliminacion, setConfirmarEliminacion] = useState(false);

    const [compose, setCompose] = useState({ abierto: false, inicial: {} });
    
    const { mutate } = useSWRConfig();

    useEffect(() => {
        const fetchResenas = async () => {
            setLoading(true);
            try {
                const resultado = await fetch(`${baseUrl}/api/resennas/search/allResennas`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                if (!resultado.ok) throw new Error("Error al cargar reseñas");
                const datos = await resultado.json();
                setResenas(datos);
            } catch (error) {
                console.error("Error al obtener las reseñas:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchResenas();
    }, []);

    const manejarVistaResenna = (resena) => {
        setSeleccion(resena);
        setAbierto(true);
    };

    // Abrir diálogo para confirmar eliminación
    const SolicitarEliminacionResenna = (resena) => {
        setAbierto(false);
        setSeleccion(resena);
        setConfirmarEliminacion(true);
    };

    const manejarEliminacionResena = async () => {
        if (!seleccion) return;
        try {
            const res = await fetch(`${baseUrl}/api/resennas/${seleccion._id}`, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" },
            });
            if (!res.ok) throw new Error("No se pudo eliminar");
            // Actualizamos el estado local
            setResenas((prev) => prev.filter((r) => r._id !== seleccion._id));
            mutate(`${baseUrl}/api/resennas/admin`);
            Swal.fire({
                icon: 'success',
                title: '¡Éxito!',
                text: 'Reseña eliminada correctamente',
                confirmButtonText: 'Aceptar'
            });
        } catch (error) {
            console.error("Error al eliminar la reseña:", error);
             Swal.fire({
                icon: 'error',
                title: 'Error en el servidor',
                text: `Ha ocurrido un error inesperado al eliminar la reseña`,
                confirmButtonText: 'Aceptar'
            });
        } finally {
            setConfirmarEliminacion(false);
            setSeleccion(null);
        }
    };

    // Abrir diálogo para componer mensaje al usuario
    const manejarEnviarMensaje = (usuario) => {
        // Llenamos los datos iniciales del mensaje
        setCompose({
        abierto: true,
        inicial: {
            Destinatarios: usuario, 
            Asunto: "",
            Contenido: "",
            Archivo: null,
            respuestaA: false,
            leerSoloDestinatarios: true,
            leerSoloAsunto: false,
        },
        });
    };

    // Cerrar cualquier diálogo
    const manejarCierre = () => {
        setAbierto(false);
        setSeleccion(null);
    };

    const GridTabla = ({ resenas, manejarVistaResenna, SolicitarEliminacionResenna, manejarEnviarMensaje }) => {

        const columns = useMemo(() => [
            {
                field: "usuario",
                headerName: "Cliente",
                width: 180,
                renderCell: (params) => { 
                    if(params.row.usuario?.Usuario){
                        return <span>{params.row.usuario?.Usuario}</span>
                    }
                    else{
                        return <span>Cliente eliminado</span>
                    }
                },
                valueGetter: (value, row) => row.usuario?.Usuario || "—",
                sortable: true,
                filterable: true,
            },
            {
                field: "contenido",
                headerName: "Contenido",
                width: 240,
                renderCell: (params) =>  {
                    if(params.row.contenido.Nombre === null){
                            return <span>Producto eliminado</span>;
                    }

                    return <span>{params.row.contenido.Nombre}</span>
                    
                },
                valueGetter: (value, row) => row.contenido?.Nombre || "—",
                sortable: true,
                filterable: true,
            },
            {
                field: "tutor",
                headerName: "Tutor",
                width: 180,
                renderCell: (params) => { 
                    if(params.row.contenido?.tutor?.Usuario){
                        return <span>{params.row.contenido?.tutor?.Usuario}</span>
                    }
                    else{
                        return <span>Tutor eliminado</span>
                    }
                },
                valueGetter: (value, row) => row.contenido?.tutor?.Usuario || "—",
                sortable: true,
                filterable: true,
            },
            {   
                field: "Fecha",
                headerName: "Fecha",
                width: 180,
                renderCell: (params) => {
                    const rawFecha = params.row.Fecha;
                    const fecha = new Date(rawFecha);
                    if (isNaN(fecha)) return "Fecha inválida";
                    return fecha.toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric"
                    }).replace(/\//g, "-");
                },
                valueGetter: (value, row) => new Date(row.Fecha),
                sortComparator: compararFecha,
                sortable: true,   
                filterable: true,
                filterOperators: getGridDateOperators()
                    .filter((operator) => operator.value !== 'isAnyOf')
                    .map((operator) => ({
                        ...operator,
                        InputComponent: operator.InputComponent
                            ? ValorFechaIntroducido
                            : undefined,
                    })),
            },
            {
                field: "acciones",
                headerName: "Acciones",
                width: 600,
                renderCell: (params) => {
                    const resena = params.row;
                    return (
                        <div style={{display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center'}}>
                            <button
                                className="botonTabla1A"
                                onClick={() => manejarVistaResenna(resena)}
                            >
                                Ver
                            </button>
                            <button
                                className="botonTabla3A"
                                onClick={() => SolicitarEliminacionResenna(resena)}
                            >
                                Eliminar
                            </button>
                            <button
                                className="botonTablaAdmin"
                                onClick={() => manejarEnviarMensaje(resena.usuario?.Usuario)}
                            >
                                Enviar mensaje al cliente
                            </button>
                            <button
                                className="botonTablaAdmin"
                                onClick={() => manejarEnviarMensaje(resena.contenido?.tutor.Usuario)}
                            >
                                Enviar mensaje al tutor
                            </button>
                        </div>
                    );
                },
                sortable: false,
                filterable: false,
            },
        ], []
    );
    
        return (
            <div className="gridContainerAdmin">
                <DataGrid
                    rows={resenas}
                    columns={columns.map((col) => ({
                        ...col,
                        headerAlign: "center",
                        align: "center",
                    }))}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    getRowId={(row) => row._id}
                    sx={{
                        borderColor: 'var(--text-principal)',
                        color: 'var(--text-principal)', 
                        fontSize: "14px",
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#fff',
                            color: 'black',
                            fontWeight: 'bold',
                            borderBottom: '0.25px solid var(--text-principal)'
                        },
                        "& .MuiTablePagination-displayedRows": {
                            color: "#fff", 
                        },
                        "& .MuiDataGrid-footerContainer": {
                            color: 'var(--text-principal)',
                            fontWeight: "bold",
                        },
                        '& .MuiSvgIcon-root': {
                            color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                        },
                        '& .MuiDataGrid-sortIcon': {
                            color: 'black', // Cambia el color de la flecha de ordenación
                        },
                        '& .MuiDataGrid-menuIconButton svg': {
                            color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                        },
                        // 'Filas por página:' texto
                        "& .MuiTablePagination-selectLabel": {
                            color: 'var(--text-principal)',
                        },
                        // Selector desplegable (100)
                        "& .MuiInputBase-root": {
                            color: "var(--text-principal)",
                        },
                    
                        // Opciones del selector al abrirse
                        "& .MuiMenuItem-root": {
                            color: "black", // texto de los items cuando se despliega el select
                        },
                    
                        // '1–7 de 7'
                        "& .MuiTablePagination-displayedRows": {
                            color: "var(--text-principal)",
                        },
                    
                        // Flechas de navegación
                        "& .MuiSvgIcon-root": {
                            color: "var(--text-principal)",
                        },
                        // Bordes de las filas
                        '& .MuiDataGrid-row': {
                            borderBottom: '0.25px solid var(--text-principal)', 
                        },
                        // Borde del selector si quieres quitarlo o estilizarlo
                        "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#fff",
                        },
                    
                        // Icono del desplegable (flecha abajo del select)
                        "& .MuiSelect-icon": {
                            color: "var(--text-principal)",
                        },
                        // Icono menú cabecera
                        "& .MuiDataGrid-columnHeaderMenuIcon": {
                            color: "black",
                        },
                    }}
                    localeText={{
                        ...esES.components.MuiDataGrid.defaultProps.localeText,
                        rowsPerPage: "Filas por página:",
                    }}
                />
            </div>
        );
    };
    return(
    <div>
        <h2 style={{marginBottom:'10px'}}>Reseñas</h2>   
        <div className="containerAdmin">
            {loading ? (
                <div className="noMostrar">
                    <p>Cargando reseñas...</p>
                </div>
            ) : (resenas.length === 0) ? (
                <div className="noMostrar">
                    <p>No existe ninguna reseña</p>
                </div>
            ) : (
                <GridTabla 
                    resenas={resenas}
                    manejarVistaResenna={manejarVistaResenna} 
                    SolicitarEliminacionResenna={SolicitarEliminacionResenna}
                    manejarEnviarMensaje={manejarEnviarMensaje}
                />
            )}
            {/*Modal para ver reseña */}
            
            <Dialog open={abierto} onClose={manejarCierre} fullWidth maxWidth="md">
                <DialogTitle>
                    {`Reseña de ${seleccion?.contenido?.Nombre || ""}`}
                </DialogTitle>
                <DialogContent dividers>
                    {seleccion && (
                        <div className="modalVerResennas">
                            <CardResennas resena={seleccion} style={{width: '100px'}} />
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={manejarCierre}>Cerrar</Button>
                </DialogActions>
            </Dialog>
            

            {/*Modal para eliminar reseña */}
            <Dialog
                open={confirmarEliminacion}
                onClose={() => setConfirmarEliminacion(false)}
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    {`Eliminar reseña de ${seleccion?.contenido?.Nombre}`}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        ¿Estás seguro de que deseas eliminar esta reseña? Después no podrá deshacer el cambio
                    </Typography>
                </DialogContent>
                    <DialogActions>
                        <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={() => setConfirmarEliminacion(false)}>No</Button>
                        <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} color="error" onClick={manejarEliminacionResena}>
                            Sí, eliminar
                        </Button>
                    </DialogActions>
            </Dialog>

            <ComponerMensajeDialog
                abierto={compose.abierto}
                inicial={compose.inicial}
                onClose={() => setCompose({ abierto: false, inicial: {} })}
            />
        </div>
    </div>
    )
};


//Grid Usuarios
export const UsuariosGrid = () => {
    const PerfilRenderer = ({ usuario }) => {
        return(
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <img src={`data:image/png;base64,${usuario.ImagenPerfil}`} alt={`${usuario.Nombre } ${usuario.Apellidos}`} style={{width: "50px", height: "50px", borderRadius: "50%"}}/>
            </div>
        );
    };

    const AccionRenderer = ({ usuario, verDetalles, solicitarEliminarUsuario, enviarMensaje }) => (
        <div style={{ display: "flex", gap: 8, justifyContent: "center", alignItems: "center"}}>
            <button className="botonTabla1A"  onClick={() => verDetalles(usuario)}>
                Ver
            </button>
            <button className="botonTabla3A" onClick={() => solicitarEliminarUsuario(usuario)}>
                Eliminar
            </button>
            <button className="botonTablaAdmin" onClick={() => enviarMensaje(usuario)}>
                Mensaje
            </button>
        </div>
    );

    const compararTexto = (v1, v2) => {
        const nombre1 = v1.toString();
        const nombre2 = v2.toString();
        return nombre1 > nombre2 ? 1 : nombre1 < nombre2 ? -1 : 0;
    };

    
    const compararFecha = (v1, v2) => new Date(v1) - new Date(v2);


    //Filtrado

    //Filtrar Fecha
    function ValorFechaIntroducido(props) {
        const { item, applyValue, focusElementRef } = props;

        // Estado para la fecha
        const [fecha, setFecha] = useState(
            item.value
            ? new Date(item.value).toISOString().split('T')[0]  // Convierte el Date a "YYYY-MM-DD"
            : ''
        );
        const dateRef = React.useRef(null);

        React.useImperativeHandle(focusElementRef, () => ({
            focus: () => {
                if (dateRef.current) {
                    dateRef.current.focus();
                }
            },
        }));

        const handleFilterChange = (event) => {
            const newValue = event.target.value; // Viene en "YYYY-MM-DD"
            setFecha(newValue);
            if (newValue === '') {
            applyValue({ ...item, value: null });
            } else {
            const dateObj = new Date(newValue);
            if (!isNaN(dateObj)) {
                applyValue({ ...item, value: dateObj }); // Se envía el objeto Date
            } else {
                applyValue({ ...item, value: null });
            }
            }
        };
        
        return (
        <Box
            sx={{
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: 48,
                pl: '20px',
            }}
            >
            
            <TextField
                label="Fecha"
                type="date"
                value={fecha}
                onChange={handleFilterChange}
                inputRef={dateRef}
                InputLabelProps={{
                    shrink: true,
                }}
            />
        </Box>
        );
    }

    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);

    // Para el diálogo "Ver detalles"
    const [seleccion, setSeleccion] = useState(null);
    const [dialogVerAbierto, setDialogVerAbierto] = useState(false);

    // Para el diálogo "Confirmar eliminación"
    const [confirmarEliminacionUsuario, setConfirmarEliminacionUsuario] = useState(false);

    // Para el diálogo de composición de mensaje
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    useEffect(() => {
        const fetchUsuarios = async () => {
            setLoading(true);
            try{
                const resultado = await fetch(`${baseUrl}/api/users`, {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                if(!resultado.ok) throw new Error("Error al cargar usuarios");
                const datos = await resultado.json();
                const usuariosFiltrados = datos.filter((us) => us.Tipo !== "Administrador");
                setUsuarios(usuariosFiltrados);
            } catch(error){
                console.error("Error obteniendo usuarios: ", error);
            } finally{
                setLoading(false);
            }
        };
        fetchUsuarios();
    }, []);

    const verDetalles = (usuario) => {
        setSeleccion(usuario);
        setDialogVerAbierto(true);
    };

    const solicitarEliminarUsuario = (usuario) => {
        setSeleccion(usuario);
        setConfirmarEliminacionUsuario(true);
    };

    const manejarEliminacionUsuario = async () => {
        if (!seleccion) return;
        try {
        const res = await fetch(`${baseUrl}/api/users/${seleccion._id}`, {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("No se pudo eliminar");
        setUsuarios((prev) => prev.filter((u) => u._id !== seleccion._id));
         Swal.fire({
                icon: 'success',
                title: 'Usuario eliminado!',
                text: `La cuenta de usuario se ha eliminado correctamente.`,
                confirmButtonText: 'Aceptar'
            })   
        } catch (err) {
            console.error("Error al eliminar usuario:", err);
             Swal.fire({
                icon: 'error',
                title: 'Error en el servidor',
                text: `Ha ocurrido un error inesperado al eliminar al usuario.`,
                confirmButtonText: 'Aceptar'
            });
        } finally {
            setConfirmarEliminacionUsuario(false);
            setSeleccion(null);
        }
    };

    const enviarMensaje = (usuario) => {
        setCompose({
        abierto: true,
        inicial: {
            Destinatarios: usuario.Usuario,
            Asunto: "",
            Contenido: "",
            Archivo: null,
            respuestaA: false,
            leerSoloDestinatarios: true,
            leerSoloAsunto: false,
        },
        });
    };

    const cerrarVerDialog = () => {
        setDialogVerAbierto(false);
        setSeleccion(null);
    };
    

//Grid tabla componente
const GridTabla = ({ usuarios, verDetalles, solicitarEliminarUsuario }) => {
    const columns = useMemo(() => [
    {
        field: "ImagenPerfil",
        headerName: "Img. perfil",
        width: 100,
        renderCell: (params) => {
            const usuario=params.row;
            return <PerfilRenderer usuario={usuario} />
        },
        valueGetter: (value, row) => row.Nombre,
        sortable: false,
        filterable: false,
    },
    {
        field: "Nombre",
        headerName: "Nombre",
        width: 140,
        valueGetter: (value, row) => row.Nombre,
        sortComparator: compararTexto,
        sortable: true,
        filterable: true,
    },
    {
        field: "Apellidos",
        headerName: "Apellidos",
        width: 180,
        valueGetter: (value, row) => row.Apellidos,
        sortComparator: compararTexto,
        sortable: true,
        filterable: true,
    },
    {
        field: "Usuario",
        headerName: "Usuario",
        width: 140,
        valueGetter: (value, row) => row.Usuario,
        sortComparator: compararTexto,
        sortable: true,
        filterable: true,
    },
    {
        field: "Tipo",
        headerName: "Tipo",
        width: 120,
        valueGetter: (value, row) => row.Tipo,
        sortComparator: compararTexto,
        sortable: true,
        filterable: true,
    },
    {   
        field: "FechaNacimiento",
        headerName: "Fecha de nacimiento",
        width: 180,
        renderCell: (params) => {
            const rawFecha = params.row.FechaNacimiento;
            const fecha = new Date(rawFecha);
            if (isNaN(fecha)) return "Fecha inválida";
            return fecha.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }).replace(/\//g, "-");
        },
        valueGetter: (value, row) => new Date(row.FechaNacimiento),
        sortComparator: compararFecha,
        sortable: true,   
        filterable: true,
        filterOperators: getGridDateOperators()
            .filter((operator) => operator.value !== 'isAnyOf')
            .map((operator) => ({
                ...operator,
                InputComponent: operator.InputComponent
                    ? ValorFechaIntroducido
                    : undefined,
            })),
    },
    {   
        field: "FechaCreacion",
        headerName: "Fecha de creacion",
        width: 180,
        renderCell: (params) => {
            const rawFecha = params.row.FechaCreacion;
            const fecha = new Date(rawFecha);
            if (isNaN(fecha)) return "Fecha inválida";
            return fecha.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }).replace(/\//g, "-");
        },
        valueGetter: (value, row) => new Date(row.FechaCreacion),
        sortComparator: compararFecha,
        sortable: true,   
        filterable: true,
        filterOperators: getGridDateOperators()
            .filter((operator) => operator.value !== 'isAnyOf')
            .map((operator) => ({
                ...operator,
                InputComponent: operator.InputComponent
                    ? ValorFechaIntroducido
                    : undefined,
            })),
    },
    {
        field: "Acciones",
        headerName: "Acciones",
        width: 300,
        renderCell: (params) => (
          <AccionRenderer
            usuario={params.row}
            verDetalles={verDetalles}
            solicitarEliminarUsuario={solicitarEliminarUsuario}
            enviarMensaje={enviarMensaje}
          />
        ),
        sortable: false,
        filterable: false,
    },
    ],[]
);

return (
    <div className="gridContainerAdmin">
        <DataGrid 
            rows={usuarios}
            columns={columns.map(col => ({
                ...col,
                headerAlign: 'center', // Centra el encabezado de la columna
                align: 'center', // Centra el contenido de la celda
            }))}                
            pageSize={20}
            rowsPerPageOptions={[20]}
            disableSelectionOnClick
            getRowId={(row) => row._id}
            sx={{
                borderColor: 'var(--text-principal)',
                color: 'var(--text-principal)',  
                fontSize: "14px",
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#fff',
                    color: 'black',
                    fontWeight: 'bold',
                    borderBottom: '0.25px solid var(--text-principal)'

                },
                "& .MuiTablePagination-displayedRows": {
                    color: "#fff", 
                },
                "& .MuiDataGrid-footerContainer": {
                    color: 'var(--text-principal)',
                    fontWeight: "bold",
                },
                '& .MuiSvgIcon-root': {
                    color: 'black', // Cambia el color de los íconos en general (como la flecha de ordenación y los tres puntos)
                },
                '& .MuiDataGrid-sortIcon': {
                    color: 'black', // Cambia el color de la flecha de ordenación
                },
                '& .MuiDataGrid-menuIconButton svg': {
                    color: 'black', // Cambia el color del ícono del menú de la columna (los tres puntos)
                },
                // 'Filas por página:' texto
                "& .MuiTablePagination-selectLabel": {
                    color: 'var(--text-principal)',
                },
                // Selector desplegable (100)
                "& .MuiInputBase-root": {
                    color: "var(--text-principal)",
                },
            
                // Opciones del selector al abrirse
                "& .MuiMenuItem-root": {
                    color: "black", // texto de los items cuando se despliega el select
                },
            
                // '1–7 de 7'
                "& .MuiTablePagination-displayedRows": {
                    color: "var(--text-principal)",
                },
            
                // Flechas de navegación
                "& .MuiSvgIcon-root": {
                    color: "var(--text-principal)",
                },
                '& .MuiDataGrid-row': {
                    borderBottom: '0.25px solid var(--text-principal)', 
                },
                // Borde del selector si quieres quitarlo o estilizarlo
                "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#fff",
                },
            
                // Icono del desplegable (flecha abajo del select)
                "& .MuiSelect-icon": {
                    color: "var(--text-principal)",
                },
                // Icono menú cabecera
                "& .MuiDataGrid-columnHeaderMenuIcon": {
                        color: "black",
                },
            }}
            localeText={{
                ...esES.components.MuiDataGrid.defaultProps.localeText,
                rowsPerPage: "Filas por página:",
            }}
            
        />
    </div>
);
};

  return(
    <div>
        <h2 style={{marginBottom:'10px'}}>Usuarios</h2>   
        <div className="containerAdmin">
            {loading ? (
                <div className="noMostrar">
                    <p>Cargando usuarios...</p>
                </div>
            ) : (usuarios.length === 0) ? (
                <div className="noMostrar">
                    <p>No existe ningún Usuario</p>
                </div>
            ) : (
                <GridTabla 
                    usuarios={usuarios}
                    verDetalles={verDetalles} 
                    solicitarEliminarUsuario={solicitarEliminarUsuario}
                />
            )}

            <Dialog
                open={dialogVerAbierto}
                onClose={cerrarVerDialog}
                fullWidth
                maxWidth="sm"
            >
            <DialogTitle>
                {seleccion ? `Usuario: ${seleccion.Usuario}` : ""}
            </DialogTitle>
                <DialogContent dividers>
                    {seleccion && (
                        <>
                            <Typography gutterBottom>
                                <strong>Nombre:</strong> {seleccion.Nombre} {seleccion.Apellidos}
                            </Typography>
                            <Typography gutterBottom>
                                <strong>Correo:</strong> {seleccion.Correo}
                            </Typography>
                            <Typography gutterBottom>
                                <strong>Tipo:</strong> {seleccion.Tipo}
                            </Typography>
                            <Typography gutterBottom>
                                <strong>Fecha Nac.:</strong>{" "}
                                {new Date(seleccion.FechaNacimiento)
                                .toLocaleDateString("es-ES", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })
                                .replace(/\//g, "-")}
                            </Typography>
                            <Typography gutterBottom>
                                <strong>Fecha creación:</strong>{" "}
                                {new Date(seleccion.FechaCreacion)
                                .toLocaleDateString("es-ES", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                })
                                .replace(/\//g, "-")}
                            </Typography>
                            <Typography gutterBottom>
                                <strong>Temáticas:</strong>{" "}
                                {seleccion.Tematicas.join(", ")}
                            </Typography>
                        </>
                    )}
                </DialogContent>
            <DialogActions>
                <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={cerrarVerDialog}>Cerrar</Button>
            </DialogActions>
            </Dialog>

            <Dialog
                open={confirmarEliminacionUsuario}
                onClose={() => setConfirmarEliminacionUsuario(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                    {seleccion ? `Eliminar usuario ${seleccion.Usuario}` : "Eliminar usuario"}
                </DialogTitle>
                <DialogContent>
                    <Typography>
                        ¿Estás seguro de que deseas eliminar este usuario? Esta acción no se puede
                        deshacer.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} onClick={() => setConfirmarEliminacionUsuario(false)}>No</Button>
                    <Button sx={{ 
                               textTransform: 'none',
                                '& .MuiButton-label': {
                                    textTransform: 'lowercase',         
                                    '&::first-letter': {
                                        textTransform: 'uppercase'        
                                    }
                                }
                            }} color="error" onClick={manejarEliminacionUsuario}>
                        Sí, eliminar
                    </Button>
                </DialogActions>
            </Dialog>

            <ComponerMensajeDialog
                abierto={compose.abierto}
                inicial={compose.inicial}
                onClose={() => setCompose({ abierto: false, inicial: {} })}
            />
        </div>
    </div>
  )
};


//Página de administración
const AdminPagina = () => {
    const [indiceTab, setIndiceTab] = useState(() => {
        const guardado = sessionStorage.getItem("admin_indiceTab");
        return guardado !== null ? parseInt(guardado, 10) : 0;
    });

    const handleChangeTabla = (event, nuevoValor) => {
        setIndiceTab(nuevoValor);
        sessionStorage.setItem("admin_indiceTab", nuevoValor);
    }

    useEffect(() => {
        return () => {
            sessionStorage.removeItem("admin_indiceTab");
        };
    }, []);

    return (
        <div className="principalAdmin">
            <h1>Administración</h1>
            <Tabs
                value={indiceTab}
                onChange={handleChangeTabla}
                textColor="white"
                sx={{ 
                    mb: 1,
                    '& .MuiTabs-indicator': {
                        backgroundColor: 'var(--botonAzul)',
                    },
                    '& .MuiTab-root': {
                        textTransform: 'none',       
                    }, 
                 }}
            >
                <Tab label="Clases y cursos" />
                <Tab label="Compras" />
                <Tab label="Reseñas" />
                <Tab label="Usuarios" />
            </Tabs>

            <Divider/>

            {indiceTab === 0 && (
                <Typography component="div" sx={{ height: "auto" }}>
                    <ClasesCursosGrid />
                </Typography>
            )}

            {indiceTab === 1 && (
                <Typography component="div" sx={{ height: "auto" }}>
                    <ComprasGrid />
                </Typography>
            )}

            {indiceTab === 2 && (
                <Typography component="div" sx={{ height: "auto" }}>
                    <ReseñasGrid />
                </Typography>
            )}

            {indiceTab === 3 && (
                <Typography component="div" sx={{ height: "auto" }}>
                    <UsuariosGrid />
                </Typography>
            )}
        </div>
    );
};

export default AdminPagina;

